//auth
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

//users
export const GET_USER = 'GET_USER';
export const USERS_ERROR = 'USERS_ERROR';
export const GET_USERS = 'GET_USERS';
export const GET_PHONE = 'GET_PHONE';
export const CLEAR_USER = 'CLEAR_USER';
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';

//empresas
export const GET_EMPRESAS = 'GET_EMPRESAS';
export const GET_EMPRESA = 'GET_EMPRESA';
export const EMPRESAS_ERROR = 'EMPRESAS_ERROR';